<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10">    
    @if(!processing()){
      @if(pool && poule){
        <app-superelf-cup-round [poolUser]="poolUserFromSession" [round]="poule.getRound()" class="px-0"
          [structureNameService]="structureNameService" (navigateToPoule)="navigateToPoule(pool, $event)">
        </app-superelf-cup-round>
      }
    } @else {
      <h2 class="text-center">
      <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
    </h2>
    }
  </div>
</div>


@if(!processing() && pool){
  <app-pool-navbar [current]="CupStructure" [pool]="pool" [poolUser]="poolUserFromSession">
  </app-pool-navbar>
}